import { CheckoutContext } from '@/context/CheckoutContext';
import { cn } from '@/utils/cn';
import { addCommasToNumber } from '@/utils/pricing';
import { hasPublisherHaveBackgroundImage } from '@/utils/publisher';
import { useContext } from 'react';

export const PurchasedItems = () => {
  const { purchasedItems, boot, template } = useContext(CheckoutContext);
  const hasBackgroundImage = hasPublisherHaveBackgroundImage(boot?.checkoutTheme, template.type);
  return (
    <div
      className={cn(
        'flex flex-col gap-2 max-h-[140px] md:max-h-48 overflow-y-auto scrollbar-hide',
        hasBackgroundImage && 'bg-[rgba(0,0,0,0.1)] rounded-md'
      )}
    >
      {purchasedItems.map((item, index) => (
        <div key={`${item.sku}-${item.name}-${index}`} className="flex flex-row gap-2 items-center justify-between">
          <div className="flex flex-row gap-3 items-center">
            <div
              className={cn(
                'w-12 h-12 bg-base-muted rounded-md flex items-center justify-center',
                hasBackgroundImage && 'bg-transparent'
              )}
            >
              <img className="w-9 h-9" src={item.assetUrl} alt={item.name} />
            </div>
            <div className="text-sm weight-light">{item.displayName ?? item.name}</div>
          </div>

          <div className="text-sm mr-4 weight-light">
            {item.quantityDisplay ?? addCommasToNumber(Number(item.quantity))}
          </div>
        </div>
      ))}
    </div>
  );
};
